module.exports = "pegasus/assets/logo.png";